import * as types from '../actionTypes/employee'

export function getEmployeesForLobbyist(lobbyistEmployees){
  return{
      type: types.GET_EMPLOYEE_FOR_LOBBYIST,
      lobbyistEmployees
  }
}

export function getEmployeesForLobbyistByDate(employeesForLobbyistByDate){
  return{
      type: types.GET_EMPLOYEES_FOR_LOBBYIST_BY_DATE,
      employeesForLobbyistByDate
  }
}

export function getEmployee(employee){
  return{
      type: types.GET_EMPLOYEE,
      employee
  }
}

export function updateEmployeeForLobbyist(lobbyistEmployee) {
  return{
      type: types.UPDATE_EMPLOYEE_FOR_LOBBYIST,
      lobbyistEmployee
  }
}

export function addEmployeeToLobbyist(lobbyistEmployee) {
  return{
      type: types.ADD_EMPLOYEE_TO_LOBBYIST,
      lobbyistEmployee
  }
}

export function removeEmployeeFromLobbyist(employeeId) {
  return{
      type: types.REMOVE_EMPLOYEE_FROM_LOBBYIST,
      employeeId
  }
}

export function clearEmployee() {
  return{
      type: types.CLEAR_EMPLOYEE
  }
}

export function clearEmployeesFromLobbyist() {
  return{
      type: types.CLEAR_EMPLOYEES_FOR_LOBBYIST
  }
}



// WEBPACK FOOTER //
// ./src/actions/employee.js